import axios from 'axios';
import config from '../../config';
import {
  goTo,
} from '../../actions/routing';
import {
  formatFormData,
} from '../../utils/formData';
import { FEATURE_CODES } from '../../constants/constants';
import { getErrorConfig } from '../../utils/error-code';

export const SUBMIT_INDIVIDUAL_INFO = 'SUBMIT_INDIVIDUAL_INFO';
export const POLICY_SELECTED = 'POLICY_SELECTED';
export const SUBMIT_INDIVIDUAL_INFO_FAIL = 'SUBMIT_INDIVIDUAL_INFO_FAIL';
export const HKID_SUBMIT = 'HKID_SUBMIT';
export const CHINAID_SUBMIT = 'CHINAID_SUBMIT';
export const PASSPORT_SUBMIT = 'PASSPORT_SUBMIT';
export const FORGET_USERNAME_LF_ON_HIDE_ALERT = 'FORGET_USERNAME_LF_ON_HIDE_ALERT';
export const CHANGE_VALUES = 'CHANGE_VALUES';
export const SUBMIT_RESET = 'SUBMIT_RESET';
const SUBMIT_PENDING = 'SUBMIT_PENDING';

const initialState = {
  showAlert: false,
  submitted: false,
  serverStatus: '',
  reasonCode: '',
  submittedData: {},
  isSubmitting: false,
  isLoading: false,
  errorCode: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case POLICY_SELECTED:
      return {
        ...state,
        policyType: action.policyType,
      };
    case SUBMIT_INDIVIDUAL_INFO:
      return {
        ...state,
        hash: action.hash,
        emails: action.emails,
        mobiles: action.mobiles,
        isSubmitting: false,
      };
    case SUBMIT_INDIVIDUAL_INFO_FAIL:
      return {
        hkId: action.hkId,
        chinaId: action.chinaId,
        passport: action.passport,
        isSubmitting: false,
        errorCode: action.errorCode,
      };
    case HKID_SUBMIT:
    case CHINAID_SUBMIT:
    case PASSPORT_SUBMIT:
      return {
        ...state,
        isSubmitSuccessed: true,
        isLoading: false,
      };
    case FORGET_USERNAME_LF_ON_HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
      };
    case CHANGE_VALUES:
      return {
        ...state,
        hasChangeValues: true,
      };
    case SUBMIT_PENDING:
      return {
        ...state,
        isSubmitting: true,
        isLoading: true,
      };
    case SUBMIT_RESET:
      return {
        ...state,
        isSubmitting: false,
        payload: action.payload,
      };
    default:
      return state;
  }
}

export const onPolicySelect = (link, policyType) => {
  return async (dispatch) => {
    dispatch({
      type: POLICY_SELECTED,
      policyType,
    });
    dispatch(goTo(link));
  };
};

export function hasChangeValues() {
  return (dispatch) => {
    dispatch({
      type: CHANGE_VALUES,
    });
  };
}

export const onHkIdSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: HKID_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/lifeDob`));
  };
};

export const onChinaIdSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: CHINAID_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/lifeDob`));
  };
};

export const onPassportSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: PASSPORT_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/lifeDob`));
  };
};

export const onSubmitIndividualInfoHandler = (userId) => {
  return async (dispatch, getState) => {
    const details = {
      'policyType': userId.policyType,
      'cardType': userId.cardType,
      'hkid': userId.hkId,
      'chinaid': userId.chinaId,
      'passport': userId.passport,
      'dob': userId.dob,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });
    await axios.post(`${config.webview.identityBEUrl}/customer/search`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      // customer record found
      if (!response.data.checkHash) {
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
          hkId: userId.hkId,
          chinaId: userId.chinaId,
          passport: userId.passport,
          errorCode: response.data.code,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      } else if (!response.data.axaId) { // customer register
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      } else if (response.data.iam) {
        if (response.data.iam.status.toLowerCase() === 'pre-validated') {
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/prevalidated`));
        } else if (response.data.iam.status.toLowerCase() === 'active') {
          dispatch({
            type: SUBMIT_INDIVIDUAL_INFO,
            hash: response.data.checkHash,
            emails: response.data.emails,
            mobiles: response.data.mobiles,
            policyType: response.data.policyType,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/select-new-username`));
        }
      } else { // fail case
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
          hkId: userId.hkId,
          chinaId: userId.chinaId,
          passport: userId.passport,
          errorCode: response.data.code,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      }
    }).catch((error) => {
      dispatch({
        type: SUBMIT_INDIVIDUAL_INFO_FAIL,
        hkId: userId.hkId,
        chinaId: userId.chinaId,
        passport: userId.passport,
        errorCode: error.response.data.code,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
    });
  };
};

export const submitCreateUsername = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const details = {
      'checkHash': submitValues.hash,
      'contactType': submitValues.contactType,
      'email': submitValues.email,
      'countryCode': submitValues.countryCode,
      'mobile': submitValues.mobile,
      'locale': `${getState().language.lang}`,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/account/reset`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      dispatch({
        type: SUBMIT_RESET,
        errorCode: '',
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/setup-success`));
    }).catch((error) => {
      dispatch({
        type: SUBMIT_RESET,
        errorCode: error.response.data.code,
        payload: error.response.data.payload,
      });

      const errorConfig = getErrorConfig({
        apiCode: error.response.data.code,
        featureCode: FEATURE_CODES.forgetUsername,
      });

      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
    });
  };
};

export const modalClose = () => {
  return (dispatch) => {
    dispatch({
      type: FORGET_USERNAME_LF_ON_HIDE_ALERT,
    });
  };
};
